import React from "react";
import EnrollmentForm from "../../../components/enrollments/EnrollmentForm";
export default function CoachEnrollmentFormPage() {
    return <EnrollmentForm role="COACH" />;
}
